import type { ButtonPropsVariantOverrides } from "@mui/material";
import type React from "react";
import type { DefaultTheme } from "../themes";

// eslint-disable-next-line import/prefer-default-export
export const getButtonVariantStyle = (
  theme: DefaultTheme,
  variantName: keyof ButtonPropsVariantOverrides
): React.CSSProperties => {
  const found = theme.components?.MuiButton?.variants?.find(
    (v) => "variant" in v.props && v.props.variant === variantName
  );
  return (found?.style || {}) as React.CSSProperties;
};
